// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.middle-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.input-container {
  display: flex;
  flex-direction: column;
}
.input-container .prop-label {
  font-family: "GothamBold", Arial, sans-serif;
  margin-bottom: 0.25rem;
}
.input-container .prop-label.required::after {
  content: " *";
  color: #97002e;
}
.input-container .legacy-note {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 0.8rem;
  color: #707070;
  margin-left: 0.25rem;
}
.input-container mat-form-field {
  width: 100%;
}
.input-container .api-error {
  color: #97002e;
  font-size: 0.75rem;
  margin-top: -0.75rem;
  margin-bottom: 0;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}

.loading-options {
  margin-bottom: 1rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
